// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__d55Nc","requiredAsterisk":"Info_requiredAsterisk__ZprGa"};